import React, { useEffect, useRef } from 'react'
import { translate } from '../../../../../../../utils/language'
function Text({ setItem, value, id, componentType, targetKey }) {
  const ref = useRef()
  useEffect(() => {
    if (ref.current)
      ref.current.value = value
  }, [id])
  return (
    <div className='w-[100%] border-y-1 py-2 pt-[30px] border-b-1'>
      <div className='flex justify-between  py-0 w-[100%]'>
        <label className={`text-sm px-1 text-[#8A92A6] font-medium`}>{translate(`${componentType}.${targetKey}`)}</label>
        {/* <label className="switch">
        <input type="checkbox" checked/>
        <span className="slider round"></span>
      </label> */}
      </div>
      <input
        ref={ref}
        type={"text"}
        onInput={(event) => { setItem(event?.target?.value, targetKey) }}
        className={`text-[12px] hover:border-[#f8f8f8] text-[#8A92A6] border-1 rounded box-border w-[100%] p-3 py-3 my-[10px] mb-[20px] `}
        placeholder={translate("sidebarTextInputPlaceholder").replace("{targetKey}", translate(`${componentType}.${targetKey}`))} />
    </div>
  )
}

export default Text